import { FormattedMessage } from "react-intl";
import CopyIcon from "../../../components/Common/SvgIcons/TableIcons/CopyIcon";
import ViewIcon from "../../../components/Common/SvgIcons/TableIcons/ViewIcon";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../tableColumnTypes";
import { createShotclasses } from "./createShotclasses";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";
import { roleMenuList } from "../../roleMenuList";

export const publishedByOthers = {
  label: <FormattedMessage id="MYCLASS_PUBLISHEDBYOTHERS" />,
  path: (tenantName) => `/${tenantName}/manage/publishedByOthers`,
  searchPlaceHolder: "Search published by others by name or tag",
  columns: (navigate, tenantName) => [
    {
      ID: 1,
      name: <FormattedMessage id="Report_ShotClass_Name" />,
      fieldName: "Name",
      value: (row) => (
        <div title={row?.Name}>
          {row?.Name?.length > 25 ? row?.Name?.slice(0, 23) + "..." : row?.Name}
        </div>
      ),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: "Published By",
      fieldName: "FirstName",
      value: (row) => row.FirstName,
      // + " " + row.LastName,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 3,
      name: <FormattedMessage id="MYCLASS_DATEMODIFY" />,
      fieldName: "ModifiedDate",
      value: (row) => row.ModifiedDate,
      sort: true,
      type: tableColumnTypes.DATE,
    },
    {
      ID: 4,
      name: <FormattedMessage id="MyClassStatus_lbl" />,
      fieldName: "StatusText",
      value: (row) => (row.IsDistributed ? "Distributed" : row.StatusText),
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 5,
      name: <FormattedMessage id="MyClassVideoUploadStatus_lbl" />,
      fieldName: "VideoUploadStatus",
      value: (row) =>
        row.VideoUploadStatus === 0
          ? "Not Available"
          : row.VideoUploadStatus === 1
          ? "In Progress"
          : row.VideoUploadStatus === 2
          ? "Failed"
          : row.VideoUploadStatus === 3
          ? "Processed"
          : "",
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 6,
      name: <FormattedMessage id="MYCLASS_LANGUAGE" />,
      fieldName: "LocaleDisplay",
      value: (row) => row.LocaleDisplay,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 7,
      name: <FormattedMessage id="Cer_Actions" />,
      fieldName: "",
      value: (row) => (
        <div style={{ display: "flex" }}>
          <RoleMenuChek
            feature={[
              {
                roleMenu: roleMenuList?.MANAGE?.EDIT_SHOTCLASS,
                MSOMMenu: "",
              },
            ]}
          >
            <Tooltip
              content={<FormattedMessage id="MYCLASS_COPY" />}
              direction={"bottom"}
            >
              <span
                onClick={() => {
                  localStorage.setItem(
                    "shotclassTypeFrom",
                    "publishedByOthers"
                  );
                  navigate(
                    `${createShotclasses.copypath(tenantName)}/${row.ID}`,
                    {
                      state: { from: "publishedByOthers" },
                    }
                  );
                }}
              >
                <CopyIcon />
              </span>
            </Tooltip>
          </RoleMenuChek>
          <Tooltip
            content={<FormattedMessage id="VIEW_SHOTCLASS_HOME" />}
            direction={"bottom"}
          >
            <span
              onClick={() => {
                localStorage.setItem("shotclassTypeFrom", "publishedByOthers");
                navigate(`${createShotclasses.viewpath(tenantName)}/${row.ID}`);
                // window.open(
                //   `${createShotclasses.viewpath(tenantName)}/${row.ID}`,
                //   {
                //     state: { from: "publishedByOthers" },
                //   },
                //   "_blank"
                // );
              }}
            >
              <ViewIcon />
            </span>
          </Tooltip>
        </div>
      ),
      sort: false,
    },
  ],
};
